export const STANDARD = 'STANDARD';
export const HBR = 'HBR';
export const MC_KINSEY = 'MC_KINSEY';
export const INPRACTICE = 'IN_PRACTICE';
export const GUIDE_IN_PRACTICE = 'GUIDE_IN_PRACTICE';
